import { useFormContext } from "react-hook-form";
import { Textarea } from "../ui/textarea";
import { cn } from "@/lib/utils";

export default function QuickNotesSection() {
  const { register, formState } = useFormContext();

  return (
    <div className="space-y-2">
      <Textarea
        {...register("quick_notes")}
        placeholder="Add quick notes (e.g. BP not checked today, patient anxious...)"
        rows={2}
        className={cn(
          "text-xs border border-input rounded-md bg-background transition-all duration-200",
          "focus:border-ring focus:outline-none focus-visible:ring-0",
          "hover:border-ring/60 placeholder:text-muted-foreground placeholder:font-normal",
          "resize-none min-h-[56px]",
          formState.errors?.quick_notes && "border-destructive/30 bg-destructive/5 focus:border-destructive"
        )}
        maxLength={100}
      />
      {formState.errors?.quick_notes && (
        <div className="text-xs text-destructive mt-1">
          {formState.errors.quick_notes.message as string}
        </div>
      )}
    </div>
  );
}